function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  rx: 13,
  fill: "#F4F2FF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_55237_50537)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.66602 16.6667C6.66602 16.2985 6.96449 16 7.33268 16H9.33268C9.70087 16 9.99935 16.2985 9.99935 16.6667C9.99935 17.0349 9.70087 17.3333 9.33268 17.3333H7.99935V18.6667C7.99935 19.0349 7.70087 19.3333 7.33268 19.3333C6.96449 19.3333 6.66602 19.0349 6.66602 18.6667V16.6667Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.6667 16C17.0349 16 17.3333 16.2985 17.3333 16.6667V18H18.6667C19.0349 18 19.3333 18.2985 19.3333 18.6667C19.3333 19.0349 19.0349 19.3333 18.6667 19.3333H16.6667C16.2985 19.3333 16 19.0349 16 18.6667V16.6667C16 16.2985 16.2985 16 16.6667 16Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6667 6.66602C19.0349 6.66602 19.3333 6.96449 19.3333 7.33268V9.33268C19.3333 9.70087 19.0349 9.99935 18.6667 9.99935H16.6667C16.2985 9.99935 16 9.70087 16 9.33268C16 8.96449 16.2985 8.66602 16.6667 8.66602H18V7.33268C18 6.96449 18.2985 6.66602 18.6667 6.66602Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.66602 7.33268C6.66602 6.96449 6.96449 6.66602 7.33268 6.66602H9.33268C9.70087 6.66602 9.99935 6.96449 9.99935 7.33268V9.33268C9.99935 9.70087 9.70087 9.99935 9.33268 9.99935C8.96449 9.99935 8.66602 9.70087 8.66602 9.33268V7.99935H7.33268C6.96449 7.99935 6.66602 7.70087 6.66602 7.33268Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.88915 7.06327C10.0919 7.3706 10.0072 7.78411 9.69982 7.98688C8.07146 9.06123 6.99935 10.9051 6.99935 12.9991C6.99935 13.3056 7.02229 13.6064 7.06643 13.8999C7.1212 14.264 6.87044 14.6035 6.50635 14.6583C6.14225 14.7131 5.8027 14.4623 5.74793 14.0982C5.69394 13.7393 5.66602 13.3722 5.66602 12.9991C5.66602 10.4383 6.97909 8.18456 8.96554 6.87395C9.27287 6.67118 9.68638 6.75594 9.88915 7.06327Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.06327 16.1103C7.3706 15.9075 7.78411 15.9923 7.98688 16.2996C9.06123 17.928 10.9051 19.0001 12.9991 19.0001C13.3056 19.0001 13.6064 18.9771 13.8999 18.933C14.264 18.8782 14.6035 19.129 14.6583 19.4931C14.7131 19.8572 14.4623 20.1967 14.0982 20.2515C13.7393 20.3055 13.3722 20.3334 12.9991 20.3334C10.4383 20.3334 8.18456 19.0203 6.87395 17.0339C6.67118 16.7266 6.75594 16.313 7.06327 16.1103Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.4931 11.3395C19.8572 11.2848 20.1967 11.5355 20.2515 11.8996C20.3055 12.2585 20.3334 12.6256 20.3334 12.9988C20.3334 15.5596 19.0203 17.8133 17.0339 19.1239C16.7266 19.3267 16.313 19.2419 16.1103 18.9346C15.9075 18.6273 15.9923 18.2138 16.2996 18.011C17.928 16.9366 19.0001 15.0928 19.0001 12.9988C19.0001 12.6922 18.9771 12.3914 18.933 12.098C18.8782 11.7339 19.129 11.3943 19.4931 11.3395Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9988 6.99935C12.6922 6.99935 12.3914 7.02229 12.098 7.06643C11.7339 7.1212 11.3943 6.87044 11.3395 6.50635C11.2848 6.14225 11.5355 5.8027 11.8996 5.74793C12.2585 5.69394 12.6256 5.66602 12.9988 5.66602C15.5595 5.66602 17.8133 6.97909 19.1239 8.96554C19.3267 9.27286 19.2419 9.68638 18.9346 9.88914C18.6273 10.0919 18.2138 10.0072 18.011 9.69983C16.9366 8.07146 15.0928 6.99935 12.9988 6.99935Z",
  fill: "#5F5DE8"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_55237_50537"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(5 5)"
})));

var SvgCycleCircle = function SvgCycleCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCycleCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cycle-circle.e5319d92.svg";
export { ForwardRef as ReactComponent };